const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const serverEndpoint = isLocal ? "http://localhost:5000" : window.location.origin;

export default serverEndpoint;